import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import calcomLogo from '../../calcom-logo.svg';
import './calcom-scheduled-badge.scss';

const buildRescheduleUrl = (bookingUid: string): string =>
  `https://cal.com/booking/${bookingUid}?changes=true`;

interface CalcomScheduledBadgeProps {
  calcomBookingUid: string | null;
}

const CalcomScheduledBadge = ({ calcomBookingUid }: CalcomScheduledBadgeProps) => (
  <span className="calcom-scheduled-badge">
    <img className="calcom-scheduled-badge-logo" src={calcomLogo} alt="" />
    scheduled
    {calcomBookingUid && (
      <a
        className="calcom-scheduled-badge-reschedule"
        href={buildRescheduleUrl(calcomBookingUid)}
        target="_blank"
        rel="noopener noreferrer"
        title="Reschedule in Cal.com"
      >
        <FontAwesomeIcon glyph="calendar-alt" weight="light" size="small" />
      </a>
    )}
  </span>
);

export default CalcomScheduledBadge;